<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.news.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.news.list.title"></app-i18n>
      </h1>

      <app-news-list-toolbar></app-news-list-toolbar>
      <app-news-list-filter></app-news-list-filter>
      <app-news-list-table></app-news-list-table>
    </div>
  </div>
</template>

<script>
import NewsListFilter from '@modules/news/components/news-list-filter.vue';
import NewsListTable from '@modules/news/components/news-list-table.vue';
import NewsListToolbar from '@modules/news/components/news-list-toolbar.vue';

export default {
  name: 'app-news-list-page',

  components: {
    [NewsListFilter.name]: NewsListFilter,
    [NewsListTable.name]: NewsListTable,
    [NewsListToolbar.name]: NewsListToolbar,
  },
};
</script>

<style>
</style>
